module.exports = require("preact");